<template>
  <div class="Crisis_detail">
    <div class="hoi">
      <el-descriptions title="上报明细" direction="vertical" :column="4" border>
        <el-descriptions-item label="学生姓名">{{data.realName}}</el-descriptions-item>
        <el-descriptions-item label="学生学号">{{data.userID}}</el-descriptions-item>
        <el-descriptions-item label="意识">{{ data2.Awareness}}</el-descriptions-item>
        <el-descriptions-item label="所处情境">{{data2.Situations}}</el-descriptions-item>
        <el-descriptions-item label="自知力">{{data2.Insight}}</el-descriptions-item>
        <el-descriptions-item label="情绪状态">{{data2.Situations}}</el-descriptions-item>
        <el-descriptions-item label="主要压力源">{{data2.PressureSource}}</el-descriptions-item>
        <el-descriptions-item label="风险等级">
          <span v-if="data2.FirstCrisis == 1">五级/严重而紧急</span>
          <span v-if="data2.FirstCrisis == 2">四级/重度</span>
          <span v-if="data2.FirstCrisis == 3">三级/中度</span>
          <span v-if="data2.FirstCrisis == 4">二级</span>
          <span v-if="data2.FirstCrisis == 5">一级</span>
        </el-descriptions-item>
        <el-descriptions-item label="自杀自伤或伤害他人倾向">{{data2.SuicidalFlg==1?'是':'否'}}</el-descriptions-item>
        <el-descriptions-item label="关于伤害的情况">{{data2.DamageName}}</el-descriptions-item>
        <el-descriptions-item label="关于自杀方式">{{data2.SuicideMethodsName}}</el-descriptions-item>
        <el-descriptions-item label="疑似重性精神病">{{data2.PsychosesFlg==1?'是':'否'}}</el-descriptions-item>
        <el-descriptions-item label="疑似出现">{{data2.SuspectedAppearName}}</el-descriptions-item>
        <el-descriptions-item label="既往就医史">{{data2.MedicineDescribe}}</el-descriptions-item>
        <el-descriptions-item label="咨询师综合印象及建议">{{data2.Recommendation}}</el-descriptions-item>
        <el-descriptions-item label="整体印象">{{data2.OverallImpression}}</el-descriptions-item>
        <el-descriptions-item label="建议">{{data2.Recommendation}}</el-descriptions-item>
        <el-descriptions-item label="风险监控员初核意见">{{data2.RiskMonitorCheckDetail}}</el-descriptions-item>
        <el-descriptions-item label="危机主管复核意见">{{data2.CriAdminCheckDetail}}</el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>


<script>
export default {
  data(){
    return {
      RoleID:sessionStorage.getItem('RoleID'),
      data:[],
      data2:[],
      fxtj:[],
      wk1:[],
      wk2:[],
      wk3:[],
      wk4:[],
      wk5:[],
      dialogVisible:false,
      selectAllConsultantdata:[],
      urgentStatus:'',
      wuserID:''
    }
  },
  methods:{
    

  },
  mounted() {
    this.$Http_Post('management/distressPrediction/prefabricatedTableData', {  keyNo: [this.$route.query.KeyNo][0] }).then((res) => {
      if (res.Code == 0) {
        this.data = res.Data;
      }
    });

    if([this.$route.query.sourceNo][0]){
      this.$Http_Post('management/distressPrediction/ConsultationAndCrisisReportData', {SourceNo: [this.$route.query.sourceNo][0] }).then((res) => {
        if (res.Code == 0) {
          this.data2 = res.Data;
          this.data2.DamageName=res.Data.DamageName?res.Data.DamageName.toString():''
          this.data2.SuicideMethodsName=res.Data.SuicideMethodsName?res.Data.SuicideMethodsName.toString():''
          this.data2.SuspectedAppearName=res.Data.SuspectedAppearName?res.Data.SuspectedAppearName.toString():''
        }
      });
    }else{
      this.$Http_Post('management/distressPrediction/ConsultationUnableConfirmData', {KeyNo: this.$route.query.KeyNo}).then((res) => {
        if (res.Code == 0) {
          this.data2 = res.Data;
          this.data2.DamageName=res.Data.InjurySituation
          this.data2.SuicideMethodsName=res.Data.SuicideMethod
          this.data2.SuspectedAppearName=res.Data.SuspectedAppearan
        }
      });
    }
  }
}
</script>
<style scoped>
  .Crisis_detail{width:100%;height: 100%;background-color: #fff;}
  .Crisis_detail .hoi{width: 96%;margin-left: 2%;padding-top: 20px;}
</style>